export const APP_SETTINGS = {
  BACKEND_BASE_URL:
    process.env.REACT_APP_FRONTEND_ENV === "dev"
      ? `https://compote-sightpas-dev.azurewebsites.net/api`
      : `https://${window.location.host}/api`,
  FRONTEND_BASE_URL: `https://${window.location.host}`,
};
